import React, { lazy } from 'react';
import Loadable from '../helpers/Loadable';

// project layouts

import ProtectUserRoute from '../permissions/ProtectUserRoute';

// render - pages
import Landing from '../pages/Landing';

const Tenant = Loadable(
  lazy(() => import('../pages/Tenant'))
)
const TenantAdmin = Loadable(
  lazy(()=> import('../pages/TenantAdmin'))
)
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  // element: <ProtectUserRoute />,
  children: [
    {
      path: '',
      element: <ProtectUserRoute />,
      children: [
        {
          path: '',
          element: <Landing />,
        },
        {
          path: '/tenants',
          element: <Tenant />,
        },
        {
          path: '/admins/:tenantId',
          element: <TenantAdmin />,
        },
      ],
    },
  ],
};

export default MainRoutes;
